/**
 * The Android app "Netlion Scanner" is Hub's `/scan` page in a Trusted Web
 * Activity. It opens `/scan?app=scanner`; from then on the installed app
 * stays on the scanner and never shows the rest of Hub.
 */

const FLAG = "netlion-scanner-app";
const ALLOWED = ["/scan", "/login"];

function standalone(): boolean {
  return typeof window !== "undefined" && window.matchMedia("(display-mode: standalone)").matches;
}

export function isScannerApp(search: string): boolean {
  if (typeof window === "undefined") return false;
  try {
    if (new URLSearchParams(search).get("app") === "scanner") localStorage.setItem(FLAG, "1");
    return standalone() && localStorage.getItem(FLAG) === "1";
  } catch {
    return new URLSearchParams(search).get("app") === "scanner";
  }
}

export function scannerAppAllows(pathname: string): boolean {
  return ALLOWED.includes(pathname);
}
